<template>
  <div id="layout-body">
    <div class="body-main">
      <router-view></router-view>
    </div>
    <back-top></back-top>
    <login-dialog></login-dialog>
  </div>
</template>

<script>
import backTop from '@/components/back-top'
import loginDialog from '@/components/dialog/login-dialog'

export default {
  name: "layout-body",
  data() {
    return {}
  },
  components: {
    backTop,
    loginDialog
  }
}
</script>

<style scoped lang="less">
#layout-body {
  margin-top: 64px;
  min-height: calc(100vh - 64px);
  background: var(--bg-page);
  display: flex;
  justify-content: center;
  padding: 0 16px;
}

.body-main {
  width: 100%;
  max-width: 1300px;
}
</style>
